import { defineMessages } from 'react-intl';

export const i18n: {
	addNew: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	invalidHighlight: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	replyCommentPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	staleContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unableToApplyAnnotation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unableToApplyDanglingCommentAnnotation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentHasBeenRemoved: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cannotHighlightContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewOrModifyNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteWithRepliesNotAllowed: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentAlreadyDeleted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentAlreadyDeletedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noCommentsFoundForGivenMarkerRef: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolveNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolveError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolveErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	editNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	replyNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	replyNotAllowedParentDeleted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unableToMarkDOM: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	networkError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unexpectedError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionNotPermittedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionNotPermitted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cannotReplyToResolvedComment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cannotUpdateResolvedComment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unableToGenerateStep: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentOutOfDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createTimeout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * The message below is duplicated in the next files:
	 * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
	 * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
	 *
	 * If you are going to change the message please make sure that the same changes are made in the mentioned above files
	 */
	a11yCommentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	commentActionsMenuLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyLinkTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkCopiedTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolve: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolved: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	edit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	delete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reopen: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	replyPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	replyPlaceholderWithName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reactionAriaLabelWithName: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolveThread: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	/**
	 * Collaborator Onboarding sample comment
	 */
	sampleAuthor: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleReply: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleReplyPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleReplyTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleDeleteHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleDeleteIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleDeleteTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sampleCloseIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapsedRepliesMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unreadInlineComment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deletedCommentActionLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolvedText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resolvedFlagText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deletedText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	goToCommentCTA: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	undoCTA: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentDeleted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	originalContentDeleted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	thisContentWasDeleted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewDeletedContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseDeletedContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addNew: {
		id: 'inline-comments-common.reactions.add.new',
		description: 'Message displayed in button to add a new reaction.',
		defaultMessage: 'Add new',
	},
	invalidHighlight: {
		id: 'inline-comments-common.error.invalid.highlight',
		defaultMessage: 'We’re having trouble adding your comment. Try highlighting more or less text.',
		description:
			'A message informing the user we had issues adding their comment and to select more/less text',
	},
	replyCommentPlaceholder: {
		id: 'inline-comments-common.reply-comment-placeholder',
		defaultMessage: 'Reply',
		description: 'A placeholder informing the user that the it is reply comment add prompt',
	},
	staleContent: {
		id: 'inline-comments-common.error.stale.content',
		defaultMessage: 'Refresh to view the latest updates, and try adding your comment again.',
		description: 'A message informing the user that the content is old and needs to be refreshed',
	},
	viewNotPermitted: {
		id: 'inline-comments-common.error.view.not.permitted',
		defaultMessage:
			'Your permission settings don’t allow you to view this comment. Check with your administrator if you need this ability.',
		description: "A message informing the user they don't have permissions to view comments",
	},
	createNotPermitted: {
		id: 'inline-comments-common.error.create.not.permitted',
		defaultMessage:
			'You can’t create comments in this space. A space admin can modify your permissions.',
		description: "A message informing the user they don't have permissions to create comments",
	},
	unableToApplyAnnotation: {
		id: 'inline-comments-common.error.unable.to.apply.annotation',
		defaultMessage:
			'Something went wrong when adding this comment to the document. Refresh to see your comment.',
		description:
			'A message informing the user the comment was created, but could not be applied to the active document',
	},
	unableToApplyDanglingCommentAnnotation: {
		id: 'inline-comments-common.error.unable.to.apply.dangling.comment.annotation',
		defaultMessage:
			'Your comment was created but could not be added to the document because the text has been changed or removed.',
		description:
			'A message informing the user the comment was created, but could not be applied to the active document',
	},
	contentHasBeenRemoved: {
		id: 'inline-comments-common.error.create.content.removed',
		defaultMessage:
			'The text you highlighted has already been deleted by someone else. Refresh to view the latest updates.',
		description:
			'A message informing the user they cannot create a comment because the content has been removed by another user',
	},
	cannotHighlightContent: {
		id: 'inline-comments-common.error.cannot.highlight.content',
		defaultMessage:
			'An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates.',
		description:
			'A message informing the user they cannot create a comment because the highlighted content may be outdated',
	},
	viewOrModifyNotPermitted: {
		id: 'inline-comments-common.error.view.or.modify.not.permitted',
		defaultMessage:
			'You can’t view or modify comments in this space. A space admin can modify your permissions.',
		description:
			"A message informing the user they don't have permissions to view or modify comments",
	},
	deleteWithRepliesNotAllowed: {
		id: 'inline-comments-common.error.delete.with.replies',
		defaultMessage:
			'You can’t delete this comment anymore because someone else replied to it. Refresh to see all replies.',
		description:
			'An error message informing the user they cannot delete this inline comment because someone has replied to it. They should reload the page to see the reply.',
	},
	commentAlreadyDeleted: {
		id: 'inline-comments-common.error.comment.already.deleted',
		defaultMessage:
			'This comment has been deleted by someone else. Refresh to view the latest updates.',
		description:
			'An error message informing the user they cannot delete or edit this inline comment because it has already been deleted. They should reload the page to see the reply.',
	},
	commentAlreadyDeletedTitle: {
		id: 'inline-comments-common.error.comment.already.deleted.title',
		defaultMessage: 'Unable to delete comment',
		description:
			'Title to display in Flag to inform user that the comment they are trying to delete is already deleted.',
	},
	noCommentsFoundForGivenMarkerRef: {
		id: 'inline-comments-common.error.no.comments.found.for.given.marker.ref',
		defaultMessage: 'This comment couldn’t be found. Refresh to view the latest updates.',
		description:
			'An error message informing the user they cannot view this inline comment because it could not be found. They should reload the page to view the latest updates.',
	},
	resolveNotPermitted: {
		id: 'inline-comments-common.error.resolve.not.permitted',
		defaultMessage:
			'You can’t resolve comments in this space. A space admin can modify your permissions.',
		description: "A message informing the user they don't have permissions to resolve comments",
	},
	resolveError: {
		id: 'inline-comments-common.error.resolve.error',
		defaultMessage:
			'We failed to resolve your comment due to an error. Try resolving the comment again.',
		description: 'An error message informing the user resolving this comment failed.',
	},
	resolveErrorTitle: {
		id: 'inline-comments-common.error.resolve.error.title',
		defaultMessage: 'Failed to resolve comment',
		description: 'Title to display in Flag to inform user when resolving a comment failed.',
	},
	deleteError: {
		id: 'inline-comments-common.error.delete.error',
		defaultMessage:
			'We failed to delete your comment due to an error. Try deleting the comment again.',
		description: 'An error message informing the user deleting this comment failed.',
	},
	deleteErrorTitle: {
		id: 'inline-comments-common.error.delete.error.title',
		defaultMessage: 'Failed to delete comment',
		description: 'Title to display in Flag to inform user when deleting a comment failed.',
	},
	editNotPermitted: {
		id: 'inline-comments-common.error.edit.not.permitted',
		defaultMessage:
			'You can’t edit comments in this space. A space admin can modify your permissions.',
		description: "A message informing the user they don't have permissions to edit comments",
	},
	replyNotPermitted: {
		id: 'inline-comments-common.error.reply.not.permitted',
		defaultMessage:
			'You can’t reply to comments in this space. A space admin can modify your permissions.',
		description: "A message informing the user they don't have permissions to add replies",
	},
	replyNotAllowedParentDeleted: {
		id: 'inline-comments-common.error.reply.not.allowed.parent.deleted',
		defaultMessage:
			'You can’t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates.',
		description:
			'An error message telling the user they cannot reply to a comment because it has already been deleted',
	},
	unableToMarkDOM: {
		id: 'inline-comments-common.error.unable.to.mark.dom',
		defaultMessage: 'Your comment has been successfully created. Refresh to view it.',
		description:
			'A message to tell the user their comment is created, but the mark could not be added to the DOM',
	},
	networkError: {
		id: 'inline-comments-common.error.network',
		defaultMessage:
			"Your comment wasn't added due to a network error. Check your connection and try again.",
		description: 'A message explaining a network error occurred',
	},
	unexpectedError: {
		id: 'inline-comments-common.error.unexpected',
		defaultMessage:
			'Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again.',
		description: 'A message explaining an unexpected error occurred',
	},
	actionNotPermittedTitle: {
		id: 'inline-comments-common.error.action.not.permitted.title',
		defaultMessage: 'Unauthorized action',
		description:
			"A title for the generic message informing the user they don't have permissions to perform that action on comments",
	},
	actionNotPermitted: {
		id: 'inline-comments-common.error.action.not.permitted',
		defaultMessage:
			'You can’t perform that action on inline comments in this space. A space admin can modify your permissions.',
		description:
			"A generic message informing the user they don't have permissions to perform that action on comments",
	},
	cannotReplyToResolvedComment: {
		id: 'inline-comments-common.error.cannot.reply.to.resolved',
		defaultMessage:
			'You can’t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates.',
		description: 'A message telling users they cannot reply to a resolved comment',
	},
	cannotUpdateResolvedComment: {
		id: 'inline-comments-common.error.cannot.update.resolved',
		defaultMessage:
			'You can’t edit this comment because it was recently resolved by another user. Refresh to view the latest updates.',
		description: 'A message telling users they cannot edit a resolved comment',
	},
	unableToGenerateStep: {
		id: 'inline-comments-common.error.unable.to.generate.step',
		defaultMessage:
			'You can’t create a comment because something went wrong with your highlight. Close this window and create a new highlight.',
		description: "A message explaining to the user their highlight wasn't correctly created",
	},
	contentOutOfDate: {
		id: 'inline-comments-common.error.content.out.of.date',
		defaultMessage: 'You can’t create a comment here because the text has been changed or removed.',
		description: 'A message explaining the content is out of date',
	},
	createTimeout: {
		id: 'inline-comments-common.error.create.timeout',
		defaultMessage:
			'Your request to create a comment timed out. Wait a few moments and save the comment again.',
		description:
			'This is an error message shown to users when the comment they just tried to create took too long to save. Comment is a noun, not a verb.',
	},
	/**
	 * The message below is duplicated in the next files:
	 * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
	 * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
	 *
	 * If you are going to change the message please make sure that the same changes are made in the mentioned above files
	 */
	a11yCommentLabel: {
		id: 'inline-comments-common.a11y.comment.wrapper.label',
		defaultMessage: 'Comment by {username}',
		description: 'Label that announced by screen reader when user select comment',
	},
	commentActionsMenuLabel: {
		id: 'inline-comments-common.comment.actions.menu.label',
		defaultMessage: 'More actions',
		description: 'Aria-label for inline comments actions menu button',
	},
	copyLinkTooltip: {
		id: 'inline-comments-common.tooltip.copy.link',
		defaultMessage: 'Copy link to comment',
		description:
			'A message that appears in the tooltip above a button that allows users to copy link to comment',
	},
	linkCopiedTooltip: {
		id: 'inline-comments-common.tooltip.link.has.been.copied',
		defaultMessage: 'Copied!',
		description: 'A message that appears in the tooltip above after user press on copy link button',
	},
	resolve: {
		id: 'inline-comments-common.view.action.resolve',
		defaultMessage: 'Resolve',
		description: 'A clickable link allowing the user to resolve a comment',
	},

	resolved: {
		id: 'inline-comments-common.view.action.resolved',
		defaultMessage: 'Resolved',
		description:
			'The text is shown as a status label on an inline comment thread when the comment has been marked as resolved by a user.',
	},
	edit: {
		id: 'inline-comments-common.view.action.edit',
		defaultMessage: 'Edit',
		description: 'A clickable link allowing the user to edit a comment',
	},
	delete: {
		id: 'inline-comments-common.view.action.delete',
		defaultMessage: 'Delete',
		description: 'A clickable link allowing the user to delete a comment',
	},
	reopen: {
		id: 'inline-comments-common.action.reopen',
		defaultMessage: 'Reopen',
		description: 'A clickable link allowing the user to reopen a resolved comment',
	},
	replyPlaceholder: {
		id: 'inline-comments-common.reply.placeholder',
		defaultMessage: 'Reply',
		description:
			'The text is shown as placeholder text inside the reply input field of an inline comment thread when the page is rendered in server-side rendering (SSR) mode before the editor is fully loaded.',
	},
	replyPlaceholderWithName: {
		id: 'inline-comments-common.reply.placeholder.with-name',
		defaultMessage: 'Reply to {name}',
		description: 'Reply placeholder for comments, with the comment author name',
	},
	reactionAriaLabelWithName: {
		id: 'inline-comments-common.reaction.aria-label.with-name',
		defaultMessage: 'React to {name}’s comment',
		description:
			'Aria-label for Add Reaction placeholder for comments, with the comment author name',
	},
	resolveThread: {
		id: 'inline-comments-common.resolve-thread',
		defaultMessage: 'Resolve comment thread',
		description: 'Label for resolve comment thread (comment and replies) button',
	},
	/**
	 * Collaborator Onboarding sample comment
	 */
	sampleAuthor: {
		id: 'inline-comments-common.sample.comment.author',
		defaultMessage: 'Confluence',
		description: 'Author displayed for the sample comment which is the product name Confluence',
	},
	sampleBody: {
		id: 'inline-comments-common.sample.comment.body',
		defaultMessage:
			'Highlight content to add an inline comment. All viewers can see these, so it’s great for targeted discussion on a specific word or phrase',
		description:
			'Instructions informing the user how to create an inline comment, who can see it, and why it can be useful for detailed conversations',
	},
	sampleReply: {
		id: 'inline-comments-common.sample.reply.input',
		defaultMessage: 'disabled reply input',
		description: 'input label telling the user it is disabled',
	},
	sampleReplyPlaceholder: {
		id: 'inline-comments-common.sample.reply.placeholder',
		defaultMessage: 'Reply',
		description: 'placeholder text in an input field for the user to reply',
	},
	sampleReplyTooltip: {
		id: 'inline-comments-common.sample.reply.tooltip',
		defaultMessage: 'Reply is unavailable for sample comments',
		description: 'tooltip telling the user they cannot add a reply to the sample comment',
	},
	sampleDeleteHeader: {
		id: 'inline-comments-common.sample.comment.delete.header',
		defaultMessage: 'Only you can see this.',
		description: 'Informing the user that they are the only one that cant see this',
	},
	sampleDeleteIcon: {
		id: 'inline-comments-common.sample.comment.delete.icon',
		defaultMessage: 'Delete icon',
		description: 'Label telling the user that this icon is represents Delete',
	},
	sampleDeleteTooltip: {
		id: 'inline-comments-common.sample.comment.delete.tooltip',
		defaultMessage: 'Delete sample comment',
		description: 'Tooltip informing the user clicking would delete the sample comment',
	},
	sampleCloseIconLabel: {
		id: 'inline-comments-common.sample.comment.delete.icon.label',
		defaultMessage: 'Close sample comment',
		description: 'aria-label for the Close sample comment icon',
	},
	collapsedRepliesMore: {
		id: 'inline-comments-common.collapsed.replies.more',
		defaultMessage: '{numCollapsedReplies} more replies',
		description: 'text telling the user how many replies are collapsed',
	},
	unreadInlineComment: {
		id: 'inline-comments-common.unread.inline.comment',
		defaultMessage: 'This is an unread inline comment',
		description: 'label indicating an unread inline comment',
	},
	deletedCommentActionLabel: {
		id: 'inline-comments-common.deleted.comment.action.label',
		defaultMessage: `This comment has been deleted`,
		description:
			'The text is used as the accessible label for the message element shown in an inline comment thread when a comment has been deleted, identifying the element to assistive technologies.',
	},
	resolvedText: {
		id: 'inline-comments-common.resolved',
		defaultMessage: '[Resolved]',
		description:
			'The text is shown as an inline tag or prefix label on an inline comment thread to indicate it has been resolved. It appears in brackets to visually distinguish it from comment content.',
	},
	resolvedFlagText: {
		id: 'inline-comments-common.resolved.flag.text',
		defaultMessage: 'Comment resolved',
		description: 'Text in flag when current user resolves a comment',
	},
	deletedText: {
		id: 'inline-comments-common.deleted',
		defaultMessage: '[Deleted]',
		description:
			'The text is shown as an inline tag or prefix label on an inline comment thread to indicate the comment has been deleted. It appears in brackets to visually distinguish it from active comment content.',
	},
	copyLink: {
		id: 'inline-comments-common.copy.link',
		defaultMessage: 'Copy link',
		description:
			'The text is shown as a menu item or button in the action menu of an inline comment. When clicked, it copies a direct link to that specific comment to the clipboard.',
	},
	goToCommentCTA: {
		id: 'inline-comments-common.comment.reopened.flag.cta.gotocomment',
		defaultMessage: 'Go to comment',
		description:
			'CTA button text displayed in Flag for users to open the comment in the comments panel that was just resolved or reopened.',
	},
	undoCTA: {
		id: 'inline-comments-common.comment.reopened.flag.cta.undo',
		defaultMessage: 'Undo',
		description:
			'CTA button text displayed in Flag for users to undo the comment resolved or reopened action.',
	},

	contentDeleted: {
		id: 'inline-comments-common.content.deleted',
		defaultMessage: 'Content deleted',
		description: 'Text for when the content that a comment was made on has been deleted',
	},

	originalContentDeleted: {
		id: 'inline-comments-common.original.content.deleted',
		defaultMessage: 'Original content deleted',
		description:
			'The text is shown as an informational message within an inline comment thread when the page content that the comment was anchored to has been removed or deleted.',
	},
	thisContentWasDeleted: {
		id: 'inline-comments-common.dangling.comments.this.content.was.deleted',
		defaultMessage: 'This content was deleted.',
		description:
			'Text indicating that the content this comment was made on has been deleted, for the dangling comments ux',
	},
	viewDeletedContent: {
		id: 'inline-comments-common.dangling.comments.view.deleted.content',
		defaultMessage: 'View deleted content',
		description: 'Tooltip for the expand button to view deleted content',
	},
	collapseDeletedContent: {
		id: 'inline-comments-common.dangling.comments.collapse.deleted.content',
		defaultMessage: 'Collapse deleted content',
		description: 'Tooltip for the collapse button to hide deleted content',
	},
});
